export const categories = [
  {
    id: 'cpa',
    label: 'CPAs',
    icon: 'DollarSign',
    headline: 'Find a CPA for your business',
    description: 'Tax planning, bookkeeping, financial statements, and audit support',
  },
  {
    id: 'payroll',
    label: 'Payroll',
    icon: 'Calculator',
    headline: 'Find a Payroll Specialist',
    description: 'Multi-state payroll, tax filings, direct deposit, and compliance',
  },
  {
    id: 'banker',
    label: 'Bankers',
    icon: 'Building',
    headline: 'Find a Business Banker',
    description: 'SBA loans, lines of credit, equipment financing, and cash management',
  },
  {
    id: 'hr',
    label: 'HR',
    icon: 'Users',
    headline: 'Find an HR Consultant',
    description: 'Employee handbooks, compliance, recruiting, and workplace culture',
  },
  {
    id: 'insurance',
    label: 'Insurance',
    icon: 'Shield',
    headline: 'Find an Insurance Agent',
    description: 'Business insurance, liability coverage, workers comp, and risk management',
  },
  {
    id: 'retirement',
    label: 'Retirement',
    icon: 'TrendingUp',
    headline: 'Find a Retirement Planner',
    description: '401(k) setup, pension plans, succession planning, and exit strategies',
  },
];

export default categories;
